export class ConversationMessage {
    UserId: string = '';
    Message: string = '';
    Timestamp: Date = new Date();
  
    constructor(init?: Partial<ConversationMessage>) {
      Object.assign(this, init);
    }
  }
  
  export class Conversation {
    Id: string = '';
    AreaId: string = '';
    UserId: string = '';
    Comments: ConversationMessage[] = [];
    LastRead: Date | null = null;
  
    constructor(source?: Partial<Conversation>) {
      if (source) {
          Object.assign(this, source);
      }
    }
  }